export default __webpack_public_path__ + "static/media/creative.5d3bb4a5.svg";